import router from 'next/router';
import utils from '../../utils';
import User from '../../models/User';

const useAuthActions = {
  partnerRedirectToActivity: async (email: string | undefined) => {
    const partnerId = localStorage.getItem('partnerId');
    const partnerName = localStorage.getItem('partnerName');
    const uniqueTaskKey = localStorage.getItem('uniqueTaskKey');
    const externalUniqueId = localStorage.getItem('externalUniqueId');
    const userPartnerLinkId = localStorage.getItem('userPartnerLinkId');
    const partnerUserId = localStorage.getItem('partnerUserId');
    const createdByPartner = true;
    const response = await User.combinePartnerAndUser(
      partnerId,
      partnerName,
      uniqueTaskKey,
      externalUniqueId,
      userPartnerLinkId,
      partnerUserId,
      createdByPartner,
      email,
    );
    utils.removePartnerLocals();
    router.push(response.data);
  },
};

export default useAuthActions;
